<template>
  <div class="px-5 pb-5" style="height: 100%; overflow: auto">
    <div>
      <v-alert
        v-if="command.status === 'connect'"
        class="mt-2"
        outlined
        type="info"
        icon="mdi-swap-horizontal"
        text
        dense
      >
        <div>กำลังติดต่อ Device</div>
        <div style="font-size: 11px; color: #333">
          {{ dateTimeFromNow(command.date) }}
        </div>
      </v-alert>
      <v-alert
        v-if="command.status === 'process'"
        class="mt-2"
        outlined
        type="info"
        icon="mdi-autorenew"
        text
        dense
      >
        <div>รอ Device ดำเนินการ</div>
        <div style="font-size: 11px; color: #333">
          {{ dateTimeFromNow(command.date) }}
        </div>
      </v-alert>
      <v-alert
        v-if="command.status === 'success'"
        class="mt-2"
        outlined
        type="success"
        icon="mdi-check-circle-outline"
        text
        dense
      >
        <div>สำเร็จ</div>
        <div style="font-size: 11px; color: #333">
          {{ dateTimeFromNow(command.date) }}
        </div>
      </v-alert>
      <v-alert
        v-if="command.status === 'fail'"
        class="mt-2"
        outlined
        type="error"
        icon="mdi-close-circle-outline"
        text
        dense
      >
        <div>ไม่สำเร็จ</div>
        <div style="font-size: 11px; color: #333">
          {{ dateTimeFromNow(command.date) }}
        </div>
      </v-alert>
      <div v-if="command.status === 'success'">
        <div
          v-if="
            hardware.hardware_model &&
            ['acu01r', 'cru77rf', 'vf1000r'].includes(
              hardware.hardware_model.hardware_model_code
            )
          "
        >
          <div v-for="item in command.responseData" :key="item.group_key">
            <p>{{ item.group_name.replace('$total', item.items.length) }}</p>
            <v-list-item
              class="pa-0 mb-2"
              v-for="(subItem, index) in item.items"
              :key="index"
            >
              <v-list-item-content class="grey lighten-3 px-4">
                <v-list-item-title>
                  {{ subItem[0].key_name }}: {{ subItem[0].value }}
                </v-list-item-title>
                <v-list-item-subtitle
                  class="mt-1"
                  v-for="sub in subItem.slice(1)"
                  :key="sub.key_name"
                >
                  {{ sub.key_name }}:
                  <span v-if="sub.value">
                    {{ sub.value | dateTimeFormat }}
                  </span>
                  <span v-else>-</span>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </div>
        </div>
        <div v-else>
          <p>พนักงาน ( ทั้งหมด {{ command.responseData.length }} คน )</p>
          <v-list-item
            class="pa-0 mb-2"
            v-for="item in command.responseData"
            :key="item.employee_code"
          >
            <v-list-item-content class="grey lighten-3 pl-4">
              <v-list-item-title>
                รหัสพนักงาน: {{ item.employee_code }}
              </v-list-item-title>
              <v-list-item-subtitle>
                <span v-if="item.last_update_utc">
                  อัพเดทล่าสุด: {{ item.last_update_utc | dateTimeFormat }}
                </span>
                <span v-else> อัพเดทล่าสุด: - </span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </div>
      </div>
      <div v-if="command.status === 'fail'">
        <div
          v-if="
            ['acu01r', 'cru77rf', 'vf1000r'].includes(
              hardware.hardware_model.hardware_model_code
            )
          "
        >
          <div
            v-for="group in command.responseData"
            :key="group.group_key"
            class="mb-6"
          >
            <div>
              <p
                class="mb-2"
                style="font-weight: 600; font-size: 16px; color: #212121"
              >
                {{ group.group_name }}
              </p>
              <v-divider></v-divider>
              <v-list-item
                class="pl-0"
                two-line
                v-for="item in group.items"
                :key="group.group_key + '_' + item.key"
              >
                <v-list-item-content>
                  <v-list-item-subtitle>
                    {{ item.key_name }}
                  </v-list-item-subtitle>
                  <v-list-item-title>
                    {{ item.value || '-' }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </div>
          </div>
        </div>

        <div v-else>
          <v-list-item
            two-line
            v-for="(value, key) in command.responseData"
            :key="key"
          >
            <v-list-item-content>
              <v-list-item-title>{{ key.toUpperCase() }}</v-list-item-title>
              <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                {{ value }}
              </p>
            </v-list-item-content>
          </v-list-item>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

import { mapActions } from 'vuex'

export default {
  props: {
    hardware: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      command: {
        status: null,
        date: null,
        responseData: null,
      },
      syncJobId: null,
    }
  },

  filters: {
    dateTimeFormat: function (value) {
      return moment(value).format('DD/MM/YYYY HH:mm:ss')
    },
  },

  computed: {
    employeeListTranslate() {
      return this.$store.state.hardware.employeeListTranslate
    },
  },

  async mounted() {
    try {
      const { company_uuid } = this.$store.state.authentication.company

      const payload = {
        company_uuid,
        hardware_model: this.hardware.hardware_model.hardware_model_code,
        body: {
          hardware_uuid: this.hardware.hardware_uuid,
          data: null,
        },
      }

      const [_, employeeListData] = await Promise.all([
        this.fetchEmployeeListTranslate(),
        this.getEmployeeList(payload),
      ])

      this.command = {
        status: 'connect',
        date: employeeListData.create_datetime,
      }
      this.syncJob(employeeListData.sync_job_uuid)
    } catch (error) {
      if (error.response && error.response.data) {
        this.command = {
          status: 'fail',
          date: new Date(),
          responseData: {
            Type: 'Get Employees Fail',
            Message: error.response.data.message || 'Error',
          },
        }
      }
    }
  },

  methods: {
    ...mapActions({
      getEmployeeList: 'hardware/getEmployeeList',
      fetchJob: 'hardware/fetchJob',
      fetchEmployeeListTranslate: 'hardware/fetchEmployeeListTranslate',
      userAcknowledge: 'hardware/userAcknowledge',
    }),

    syncJob(sync_job_uuid) {
      this.syncJobId = setInterval(() => {
        this.fetchJob(sync_job_uuid).then((res) => {
          this.analyzeStatus(res)
        })
      }, 1000)
    },

    clearSyncJob() {
      clearInterval(this.syncJobId)
    },

    analyzeStatus(res) {
      if (res.done_datetime && res.is_response_success) {
        if (
          res.command === 'get_employee_list' &&
          ['acu01r', 'cru77rf', 'vf1000r'].includes(
            res.hardware?.hardware_model?.hardware_model_code
          )
        ) {
          const data = res.response_json.map((item) => {
            return {
              group_key: item.group_key,
              group_name:
                this.employeeListTranslate?.groups[item.group_key]?.th ||
                item.group_key
                  .replace(/_/g, ' ')
                  .replace(/\b\w/g, (char) => char.toUpperCase()),
              items: item.items.map((subItem) =>
                Object.entries(subItem).map(([key, obj]) => ({
                  key,
                  key_name:
                    this.employeeListTranslate?.keys[key]?.th ||
                    key
                      .replace(/_/g, ' ')
                      .replace(/\b\w/g, (char) => char.toUpperCase()),
                  value: obj.value,
                  type: obj.type,
                }))
              ),
            }
          })

          this.command = {
            status: 'success',
            date: res.done_datetime,
            responseData: data,
          }
          this.clearSyncJob()
          // User Acknowledge
          if (res.user_acknowledge_datetime === null) {
            this.acknowledge(res.sync_job_uuid)
          }
        } else {
          let responseData = []
          if (res.response_json.employee.data.length > 0) {
            responseData = res.response_json.employee.data.sort((a, b) =>
              a.employee_code.localeCompare(b.employee_code)
            )
          }
          this.command = {
            status: 'success',
            date: res.done_datetime,
            responseData,
          }
          this.clearSyncJob()
          // User Acknowledge
          if (res.user_acknowledge_datetime === null) {
            this.acknowledge(res.sync_job_uuid)
          }
        }
      } else if (res.done_datetime && !res.is_response_success) {
        if (
          ['get_employee_list'].includes(res.command) &&
          ['acu01r', 'cru77rf', 'vf1000r'].includes(
            res.hardware?.hardware_model?.hardware_model_code
          )
        ) {
          const data = res.response_json.map((item) => {
            return {
              group_key: item.group_key,
              group_name:
                this.employeeListTranslate?.groups[item.group_key]?.th ||
                item.group_key
                  .replace(/_/g, ' ')
                  .replace(/\b\w/g, (char) => char.toUpperCase()),
              items: item.items.map((subItem) =>
                Object.entries(subItem).map(([key, obj]) => ({
                  key,
                  key_name:
                    this.employeeListTranslate?.keys[key]?.th ||
                    key
                      .replace(/_/g, ' ')
                      .replace(/\b\w/g, (char) => char.toUpperCase()),
                  value: obj.value,
                  type: obj.type,
                }))
              ),
            }
          })

          this.command = {
            status: 'fail',
            date: res.done_datetime,
            responseData: data,
          }
          this.clearSyncJob()
          // User Acknowledge
          if (res.user_acknowledge_datetime === null) {
            this.acknowledge(res.sync_job_uuid)
          }
          return
        }

        this.command = {
          status: 'fail',
          date: res.done_datetime,
          responseData: {
            Type: res.response_json?.error_type || 'Error Type',
            Message: res.response_json?.error_message || 'Error Message',
          },
        }
        this.clearSyncJob()
        // User Acknowledge
        if (res.user_acknowledge_datetime === null) {
          this.acknowledge(res.sync_job_uuid)
        }
      } else if (res.notice_datetime) {
        this.command = {
          status: 'process',
          date: res.notice_datetime,
        }
      }
    },

    acknowledge(sync_job_uuid) {
      this.userAcknowledge(sync_job_uuid).catch((error) => {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      })
    },

    dateTimeFromNow(value) {
      return moment.utc(value, 'YYYY-MM-DD HH:mm:ss').locale('th').fromNow()
    },
  },

  beforeDestroy() {
    this.clearSyncJob()
  },
}
</script>
